//Import Modules
import LocomotiveScroll from 'locomotive-scroll';
import $ from 'jquery';
import gsap from 'gsap';
import { load3d_er } from './3d-can_er';
import { load3d_strawberry } from './3d-strawberry';
import { load3d_rhabarber } from './3d-rhabarber';
import { playAmbientSound } from './sound';
import { initBackgroundChange } from './background-change';

//Mobile Device Check
var mobilecheck=false;
if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
  // true for mobile device
  mobilecheck=true;
};

//Session Storage Variables
var loading;
var sound;

//Define Click Sounds 
const clicksound1 = document.createElement("audio");
clicksound1.src = "can_opening.ogg";
clicksound1.crossOrigin='anonymous';
const clicksound2 = document.createElement("audio");
clicksound2.src = "bubble_sound.mp3";
clicksound2.crossOrigin='anonymous';

//Smooth Scrolling
const scroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true,
    multiplier: 1,
    touchMultiplier: 3.5,
    smartphone: {
      breakpoint: 760,
      smooth: false,
      getDirection: true,
    },
    tablet: {
      breakpoint: 1020,
      smooth: false,
      getDirection: true,
    }
});

// //GSAP Animations
const fadeInHeader = () =>{
    gsap.from('.header', { opacity: 0,  duration:1 , delay:0.5});
}
const fadeInRedCan = () =>{
  gsap.from('.webgl-er', { opacity: 0, x:100, duration:1, delay:2});
}

//Initialise Custom Cursor
function initCursor(){
  $(document).on("mousemove", (e) => {
    setTimeout(function() {
        $('.cursor')
          .eq(0)
          .css({
            left: e.pageX,
            top: e.pageY,
          });
      }, 0);
  });
}

//Set Hover Elements for Custom Cursor to change Color
function initCursorHover(){
  $('.hoverable').on("mouseenter", () => {
    $('.cursor').addClass('hover');
  });
  $('.hoverable').on("mouseleave", () => {
    $('.cursor').removeClass('hover');
  });
}

//Initialise Mobile Menu
function initMobileMenu(){
  $('.hamburger').on("click", ()=>{
    $('.menu').toggleClass('menu-open');
    $('.hamburger').toggleClass('open');
    $('.menu-items').toggleClass('show-list-items');
    $('.menu-link').toggleClass('show-links');
  });
  $('.menu-items').on("click", ()=>{
    $('.menu').toggleClass('menu-open');
    $('.hamburger').toggleClass('open');
    $('.menu-items').toggleClass('show-list-items');
    $('.menu-link').toggleClass('show-links');
  });
}

//Initialise Click Sound
function initClickSounds(){
    $('.bt-sound').on("mouseover", () => {
      console.log(sound);
      clicksound1.play();
    });
    $('.bt-sound2').on("mouseover", () => {
      clicksound2.play();
    });
    $('.logo').on("mouseover", () => {
      clicksound2.play();
    });
    $('.klick-sound').on("mouseover", () => {
      clicksound2.play();
    });
}

//Initialise Background Sound
function initAmbientSound(){
    setTimeout(()=>{
        playAmbientSound('.bg-sound-er');
    },1000);
}

//Run all functions when Document is ready
$(function() {
    fadeInHeader();
    sound= sessionStorage.getItem("soundcheck");
    $('.landing-headline').addClass("in-view");
    load3d_er();
    fadeInRedCan();
    load3d_rhabarber();
    load3d_strawberry();
    initCursor();
    initCursorHover();
    initMobileMenu();
    initBackgroundChange(scroll);
    if(sound=="true"){
        initClickSounds();
        initAmbientSound();
    }
});
